export enum DeliveryMethodEnum {
  EMAIL = 'EMAIL',
  SFTP = 'SFTP',
  BOTH = 'BOTH',
  NONE = 'NONE',
}
